import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { TextField } from "@mui/material";

interface RHFTextFieldProps {
  name: string;
  label?: string;
  placeholder?: string;
  multiline?: boolean;
  minRows?: number;
  [key: string]: any;
}

export const RHFTextField = React.memo(({
  name,
  label,
  placeholder,
  multiline,
  minRows,
  helperText,
  ...other
}: RHFTextFieldProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          sx={{
            '& .MuiOutlinedInput-root': {
              height: multiline ? 'auto' : '40px',
              borderRadius: '8px',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#C8CEE3 !important',
                borderRadius: '8px',
                borderWidth: '1px !important',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#C8CEE3 !important',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#C8CEE3 !important',
                borderWidth: '1px !important',
              },
              '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                borderColor: '#FF0000 !important',
              },
            },
            '& .MuiOutlinedInput-input': {
              padding: '4px 14px',
              fontSize: '15px',
              color: '#4E556A',
              '&::placeholder': {
                color: '#A7AAB5',
                opacity: 1,
              },
            },
            '& .MuiInputLabel-root': {
              color: '#222B45',
              fontSize: '15px',
              transform: 'translate(14px, 12px) scale(1)',
              '&.MuiInputLabel-shrink': {
                transform: 'translate(14px, -9px) scale(0.75)',
              },
            },
          }}
          fullWidth
          label={label}
          placeholder={placeholder}
          multiline={multiline}
          minRows={minRows}
          error={!!error}
          helperText={error?.message || helperText}
          {...other}
        />
      )}
    />
  );
});
